import type { I18nUtilities } from '@change-corgi/core-react/i18n';

/**
 * Formats a custom payment amount for display in a SelectionCardInput.
 *
 * Returns an empty string for non-positive values so the input can render as empty.
 * Otherwise formats the value with the user's locale, preserving exactly two
 * fraction digits when the value has a fractional part and zero otherwise.
 */
export function localizeCustomAmount(value: number, localizeNumber: I18nUtilities['localizeNumber']): string {
	if (value <= 0) return '';
	const hasDecimals = value % 1 !== 0;
	const decimals = hasDecimals ? 2 : 0;
	return localizeNumber(value, {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals,
	});
}
